<template>
  <div v-if="item">
    <div class="cursor-pointer relative show-point" @click="readMessage(item)">
      <div
        class="w-2 h-2 bg-red-500 rounded-1 absolute top-4 left-1 point"
        v-if="!item.isreaded"
      ></div>
      <div
        class="
          border-gray-200 border
          p-4
          grid grid-cols-[auto,1fr] grid-rows-[repeat(2,1fr)]
          gap-2
          items-start
          hover:border-main
        "
      >
        <p class="row-span-2">
          <img :src="item.receiver.icon" alt="" class="image w-30" />
        </p>
        <p class="self-end space-x-5">
          <span>{{ item.title }}</span>
          <span>{{ item.created.date }}</span>
        </p>
        <p>{{ item.content }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "@vue/runtime-dom";

export default defineComponent({
  props: { item: Object },
  setup(props, ctx) {
    const readMessage = (item) => {
      ctx.emit("readMessage", item.id, item.link, item.isreaded);
    };
    return { readMessage };
  },
});
</script>

<style scoped lang="scss">
.show-point {
  &:hover {
    .point {
      display: block;
    }
  }
}
</style>
